/* eslint-disable react-hooks/rules-of-hooks */
import { AppUtil, isApp } from '@/utils/appHooks';

import Decimal from 'decimal.js';
import Cookies from 'js-cookie';
import { debounce } from 'lodash';
import { Dispatch, useEffect, useRef } from 'react';

export function useDebounce<T extends (args: any) => void>(fn: T, wait = 1000) {
  const func = useRef(fn);
  func.current = fn;
  const debounceWrapper = useRef(
    debounce((args) => func.current?.(args), wait),
  );
  return debounceWrapper.current as unknown as T;
}
/**
 * 批量设置更新
 */
export function useBatchEffect(effect: any, deps?: any, wait = 0) {
  const fn = useDebounce(effect, wait);
  useEffect(fn, deps);
}

export function useWatch<T>(
  value: T,
  fn: (newVal: T, oldVal: T | undefined) => void,
  relyArr: React.DependencyList,
) {
  const oldValue = useRef<T>();
  useBatchEffect(() => {
    fn(value, oldValue.current);
    oldValue.current = value;
  }, [value, ...relyArr]);
}

export const getContentHeight = () => {
  const contentHeight =
    document.documentElement.clientHeight || document.body.clientHeight;
  return contentHeight;
};

export const getCookie = () => {
  const cookie = document.cookie;
  console.log(cookie);
};

export const getLocationParams = (keyWords: string) => {
  const href = window.location.href;
  const query = href.substring(href.indexOf('?') + 1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    // 根据指定的参数名去筛选参数值
    if (pair[0] === keyWords) {
      return decodeURI(pair[1]);
    }
  }
  return '';
};

export const getToken = () => {
  const token = Cookies.get('token');
  return token || '';
};
// 接口是否加密 1加密 0不加密
export const getEncrypted = () => {
  const encrypted = Cookies.get('encrypted');
  return encrypted || '';
};
export const getStage = () => {
  return Cookies.get('stage') || '';
};

//通过Cookies 获取deviceId
export const deviceId = () => {
  const deviceId = Cookies.get('deviceId');
  if (deviceId === 'undefined' || deviceId === 'null') return '';
  return deviceId || '';
};

//通过Cookies 获取vesion
export const version = () => {
  const vesion = Cookies.get('version');
  console.log(vesion, 'version');
  if (vesion === 'undefined' || vesion === 'null') return '';
  return vesion || '';
};

/**
 * @description 脱敏显示
 * @param v 文本
 * @param start 开始字符串显示长度
 * @param end 结束字符串显示长度
 */
export const address = (params: { v: string; start: number; end: number }) => {
  const { v, start, end } = params;
  return v && v.length > 10
    ? `${v.substring(0, start)}...${v.substring(v.length - end, v.length)}`
    : v;
};
/**
 * @description 处理价格 保留两位小数
 */
export const handlePrice = (v: number) => {
  if (typeof v === 'number') {
    let a = new Decimal(v).mul(100).floor().div(100).toNumber(),
      b = new Decimal(v).mul(100).ceil().div(100).toNumber();
    if (a < b) {
      a += 0.01;
    }
    return a.toFixed(2);
  }
  return v;
};
/**
 * @description
 */
export const uppercaseCny = (money: number) => {
  //汉字的数字
  const cnNums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  //基本单位
  const cnIntRadice = ['', '十', '百', '千'];
  //对应整数部分扩展单位
  const cnIntUnits = ['', '万', '亿', '兆'];
  //对应小数部分单位
  const cnDecUnits = ['角', '分', '毫', '厘'];
  //整数金额时后面跟的字符
  let cnInteger = '';
  //整型完以后的单位
  let cnIntLast = '';
  //最大处理的数字
  const maxNum = 999999999999999.9999;
  //金额整数部分
  let integerNum;
  //金额小数部分
  let decimalNum;
  //输出的中文金额字符串
  let chineseStr = '';
  //分离金额后用的数组，预定义
  let parts;
  if (money === 0) {
    return '';
  }
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money === 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr + '元';
  }
  //转换为字符串
  let moneyStr = money.toString();
  // money = money.toString();
  if (moneyStr.indexOf('.') === -1) {
    integerNum = moneyStr;
    decimalNum = '';
  } else {
    parts = moneyStr.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0;
    let IntLen = integerNum.length;
    for (let i = 0; i < IntLen; i++) {
      let n = integerNum.substr(i, 1);
      let p = IntLen - i - 1;
      let q = p / 4;
      let m = p % 4;
      if (n === '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m === 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast + '元';
  }
  //小数部分
  if (decimalNum !== '') {
    let decLen = decimalNum.length;
    for (let i = 0; i < decLen; i++) {
      let n = decimalNum.substr(i, 1);
      if (n !== '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      } else if (n === '0') {
        chineseStr += cnNums[Number(n)];
      }
    }
  }
  if (chineseStr === '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum === '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
};

// 金额处理
export const cny = (price: number) => {
  // return price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  return price.toFixed(2);
};

// 接口请求最大数
export const MAX_REQUEST_NUM = 9999999;

export function isPC() {
  //@ts-ignore
  if (!process?.browser) return;
  let userAgentInfo = navigator && navigator.userAgent,
    Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
      'rv:1.2.3.4',
      'windows mobile',
      'midp',
    ],
    flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) >= 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

export const getAppInit = async (
  setTop: Dispatch<number>,
  {
    statusBarStyle,
    isNoBounce,
  }: { statusBarStyle: number; isNoBounce?: boolean },
) => {
  if (isApp()) {
    const top = await AppUtil.getHeaderBarHeight();
    setTop(Number(top || 30));
  } else {
    setTop(Number(window.localStorage.getItem('header_safe_distance') || '0'));
  }
};

export const formatPhone = (str?: string) => {
  if (!str) return '';
  return str.slice(0, 3) + '******' + str.slice(-2);
};
export const sceneId = () => {
  return UMI_ENV !== 'prod' ? '1xq9suk6' : '1c6xnzvc';
};
